import { isNullOrEmpty } from "common/strings";
import { CustomField } from "domain/customField";
import Offer from "domain/offer";
import { toContractTypeWithoutPricings } from "domain/offerType";
import { evaluate } from "features/merchants/tokenEvaluator";

export function listAllowedFieldsForOffer(fields: CustomField[], offer: NullishPartial<Offer>) {
    if (offer == null || fields == null || fields.length === 0) return [];

    const allowedFields = fields
        .filter(f => isNullOrEmpty(f.mappedField) &&
            (offer.customerWillSell ? f.allowSale : f.allowPurchase) &&
            (f.allowedOfferTypes.includes(offer.type) || f.allowedContractTypes.includes(toContractTypeWithoutPricings(offer.type))) &&
            f.allowedCommodities.includes((offer.commodity ?? offer.deliveryPeriod?.commodity)?.id)
        );

    // Adding the fields coming from parent contract
    let parentFields: typeof offer.parentCustomFields = [];
    if (offer.sourceContractId != null && offer.parentCustomFields != null) {
        parentFields = offer.parentCustomFields;
    }
    const parentAllowedFields = parentFields.flatMap(pf => {
        const field = fields.find(f => f.id === pf.id);
        if (field == null) return [];
        return [{ ...field, defaultValue: pf.value }];
    });

    const additionalFields = allowedFields
        .filter(f => parentFields.every(pf => pf.id !== f.id))
        .map(f => ({ ...f, defaultValue: evaluate(f.defaultValue, offer) }));

    return [...parentAllowedFields, ...additionalFields];
}